import React from "react";

import Chart from "react-apexcharts";

import { sparklineConfig } from "../../../utils/chartConfigs";

/**
 * Tiny inline sparkline area chart for KPI cards.
 *
 * @param {{ data: number[], color?: string, height?: number, width?: number }} props
 */
const SparklineChart = ({ data, color, height, width }) => {
  if (!data || data.length === 0) return null;

  const config = sparklineConfig(data, color);

  // Separate series from options for the Chart component
  const { series, ...options } = config;

  return (
    <Chart
      height={height || 35}
      options={options}
      series={series}
      type="area"
      width={width || 100}
    />
  );
};

export default SparklineChart;
